// 统一请求路径前缀在libs/axios.js中修改
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  uploadFileRequest,
  postFileRequest,
  getFileRequest,
} from "@/libs/axios";

// 课程分类-tree数据
export const selectTreeData = (params) => {
  return postRequest("/base/examtype/selectTreeData", params);
};
// 课程分类-添加
export const addExamType = (params) => {
  return postRequest("/base/examtype/add", params);
};
// 课程分类-修改
export const editExamType = (params) => {
  return postRequest("/base/examtype/edit", params);
};
// 课程分类-删除
export const delExamType = (examTypeId) => {
  return postRequest(`/base/examtype/delById/${examTypeId}`);
};
// 课程分类-删除
export const getPhotoReviewList = (params) => {
  return postRequest(`/base/photoCollection/photoReviewPage`, params);
};
export const photoReview = (params) => {
  return postRequest(`/base/photoCollection/photoReview`, params);
};

export const photoImportList = (params) => {
  return postRequest(`/base/photoCollection/importUserPage`, params);
};
export const importPhotoUser = (params) => {
  return postFileRequest(`/base/common/importPhotoUser`, params);
};
export const downloadPhotoCheckZip = (params) => {
  return getFileRequest(`/base/photoCollection/downloadIamges`, params);
};

//下载国开图片
export const downloadIamgesByxh = (params) => {
  return getFileRequest(`/base/photoCollection/downloadIamgesByxh`, params);
};
